
import React, { useState, useEffect, useRef } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

// Components

import CommunicationPreferencesPage from '@components/individualPortal/preferences/CommunicationPreferencesPage';
import WelcomeUser from '@components/individualPortal/dashboard/WelcomeUser';

// Hooks

import { useLocation } from '@hooks/useLocation';
import useAppDispatch from '@hooks/useAppDispatch';

// ActionCreators

import { fetchExchangeDetails, fetchLanguages, fetchPreferences, savePreferences } from '@actions/individualPortal/preferences/communicationPreferencesActionCreators';
import { showModal, updateCommunicationPreferenceConfirmationCount } from '@actions/common/actionCreators';

// Utils

import { extractUserName } from '@utils/miscellaneous/extractUserName';

// Constants

import { configs } from '@constants/configs/configs';
import { INITIALS } from '@constants/common/initialObjectValues';





const CommunicationPreferencesContainer = props => {

    const {
        actions: {
            fetchPreferences,
        },
        environment,
        environment: {
            impersonationDetails,
            isState,
            stateCode
        }
    } = props;

    const { switchBackLink = null } = impersonationDetails || {};

    const { currentLocation } = useLocation();

    const [ data, updateData ] = useState(INITIALS.PREFERENCES_LOCAL_STATE);

    const communicationPrefCountReset = useRef<boolean>(false);

    const dispatch = useAppDispatch();

    useEffect(() => {
        fetchPreferences()
            .then(res => {

                const {
                    success,
                    payload
                } = res;

                if(success) {
                    const {
                        emailAddress,
                        emailMe,
                        mailingAddress,
                        mailingAddress: {
                            state
                        },
                        preferredSpokenLanguage,
                        preferredWrittenLanguage
                    } = payload;

                    updateData({
                        ...payload,
                        emailMe: emailAddress ? emailMe : false,
                        preferredSpokenLanguage: preferredSpokenLanguage ? preferredSpokenLanguage : 'English',
                        preferredWrittenLanguage: preferredWrittenLanguage ? preferredWrittenLanguage : 'English',
                        mailingAddress: {
                            ...mailingAddress,
                            ...(state === null ? { state: stateCode } : {})
                        },
                        noUpdateOfCommPrefOnEmailAddressError: true
                    });
                }
            });
        return () => {
            if (communicationPrefCountReset?.current) {
                dispatch(updateCommunicationPreferenceConfirmationCount(0));
            };
        };
    }, [  ]);

    if (data.initialState) {
        return null;
    }

    const isDashboardLocation = currentLocation === configs.routes.COMMUNICATION_PREFERENCES;
    
    const userName = environment ? extractUserName(environment) : null;

    const resetCommunicationPrefCount = () => {
        communicationPrefCountReset.current = true;
    };

    return (
        <div className={isDashboardLocation ? '' : 'desktop:grid-col-9 margin-y-5 grid-container'} id='preference-page'>
            {
                !isDashboardLocation &&
                <div id='main-content' className="grid-col-12">
                    <WelcomeUser { ...{ userName } } />
                </div>
            }
            <div className='header'>
                <h3 className='heading'>
                    <FormattedMessage id='common.communication_preferences' />
                </h3>
            </div>
            {
                environment &&
                <CommunicationPreferencesPage
                    { ...{
                        ...props,
                        isDashboardLocation,
                        isState,
                        data,
                        stateCode,
                        switchBackLink,
                        updateData,
                        resetCommunicationPrefCount,
                    } }
                />
            }
        </div>
    );
};

const mapStateToProps = state => ({
    environment: state.common.environment,
    form: state.ssap.form,
    methods: state.ssap.methods
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        fetchExchangeDetails,
        fetchLanguages,
        fetchPreferences,
        savePreferences,
        showModal
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CommunicationPreferencesContainer);